import { render, staticRenderFns } from "./overviewDialog.vue?vue&type=template&id=20cade33&scoped=true&"
import script from "./overviewDialog.vue?vue&type=script&lang=js&"
export * from "./overviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./overviewDialog.vue?vue&type=style&index=0&id=20cade33&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cade33",
  null
  
)

export default component.exports